var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorHeadset160)",
    fillRule: "evenodd",
    d: "M3 11v-.5h1.5v.5c0 .966.784 1.75 1.75 1.75h2v1.5h-2A3.25 3.25 0 0 1 3 11",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorHeadset161)",
    d: "M9.5 13.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorHeadset162)",
    fillRule: "evenodd",
    d: "M8 2.5A3.5 3.5 0 0 0 4.5 6v2H3V6a5 5 0 0 1 10 0v2h-1.5V6A3.5 3.5 0 0 0 8 2.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorHeadset163)",
    fillRule: "evenodd",
    d: "M3 11V7h1.5v4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorHeadset164)",
    fillRule: "evenodd",
    d: "M11.5 7H13v2.5a1.5 1.5 0 0 1-1.5 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorHeadset165)",
    d: "M6.25 11a.75.75 0 0 0 .75-.75v-2.5A.75.75 0 0 0 6.25 7H4.5l-1 2l1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorHeadset166)",
    d: "M9.75 7a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75h1.75l1-2l-1-2z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorHeadset160",
    x1: 6.375,
    x2: 5.671,
    y1: 13,
    y2: 10.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ca5ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70777d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorHeadset161",
    x1: 9.125,
    x2: 6.584,
    y1: 14.625,
    y2: 13.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383b3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70777d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorHeadset162",
    x1: 1.094,
    x2: 3.82,
    y1: 2.565,
    y2: 8.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b9c0c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70777d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorHeadset163",
    x1: 12.167,
    x2: 12.167,
    y1: 7,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2052cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorHeadset164",
    x1: 12.167,
    x2: 12.167,
    y1: 7,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2052cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorHeadset165",
    x1: 11.188,
    x2: 11.188,
    y1: 7,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0fafff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0067bf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorHeadset166",
    x1: 11.188,
    x2: 11.188,
    y1: 7,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0fafff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0067bf"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk);
export default __webpack_public_path__ + "static/media/talk.b8f9b613b798e5a664f62e217cef11fb.svg";
export { ForwardRef as ReactComponent };